import { indexTopics } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100">影视专题索引</h2>
          <p className="text-sm text-foreground-500 mt-3">快速找到你感兴趣的影视分类</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexTopics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              <div className="w-11 h-11 rounded-lg bg-primary-500/10 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${topic.icon} text-xl text-primary-400`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-100">{topic.title}</h3>
                  <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-accent-500/15 text-accent-400 whitespace-nowrap">
                    {topic.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1.5 leading-relaxed">{topic.desc}</p>
              </div>
              <div className="flex-shrink-0 flex items-center pt-2 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}